import { render, staticRenderFns } from "./OffsetLocations.vue?vue&type=template&id=3f4ba11c&scoped=true&"
import script from "./OffsetLocations.vue?vue&type=script&lang=js&"
export * from "./OffsetLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ba11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4ba11c')) {
      api.createRecord('3f4ba11c', component.options)
    } else {
      api.reload('3f4ba11c', component.options)
    }
    module.hot.accept("./OffsetLocations.vue?vue&type=template&id=3f4ba11c&scoped=true&", function () {
      api.rerender('3f4ba11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/OffsetLocations.vue"
export default component.exports